import React from "react";
import { RIGHT_DARK, WRONG_DARK } from "@etiquette-ui/colors";
import { CardTitleComponent } from "../../Group/styles";
import CustomMetricData from "./CustomMetricData";
import { CustomCardTemplate, CustomRow } from "../styles";

const CashCancellationsCourtesy: React.FC<{ totalSales: string, salesPerGuest: string, cashPercentage: string, cancellationPercentage: string, courtesyPercentage: string, }> = ({ totalSales, salesPerGuest, cashPercentage, cancellationPercentage, courtesyPercentage  }) => {
  return (
    <CustomCardTemplate
      background={"white"}
      noPadding={false}
      header={
        <CustomRow>
          <CardTitleComponent title={"Total"} />
          <CardTitleComponent title={"Guest"} />
          <CardTitleComponent title={"Cash %"} />
          <CardTitleComponent title={"Canc. %"} />
          <CardTitleComponent title={"Cour. %"} />
        </CustomRow>
      }
      body={
        <CustomRow>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {totalSales}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {salesPerGuest}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {cashPercentage}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={WRONG_DARK}>
              {cancellationPercentage}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={WRONG_DARK}>
              {courtesyPercentage}
            </CustomMetricData>
          </div>
        </CustomRow>
      }
    />
  );
};

export default CashCancellationsCourtesy;
